<template lang="pug">
  .guide.g-justify-center
    //- DESKTOP
    .container-desktop(v-if="$vuetify.breakpoint.mdAndUp")
      .container-first-card
        .pulse(v-show="pulseActive")
        .card-tutorial.g-flex.g-justify-center.g-align-center.cursor-pointer(@click="showDialogVideo('dialogVideo1')" :class="{'selected': dialogVideo1}")
          .play.g-flex.g-justify-center.g-align-center
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.1826 10.5956L16.1826 10.5956L16.1782 10.5981L2.46672 18.5539C2.46663 18.5539 2.46653 18.554 2.46644 18.5541C1.7596 18.9635 0.888228 18.4542 0.888228 17.6734V1.76146C0.888228 0.981933 1.75816 0.471838 2.46636 0.882879L2.46644 0.882927L16.1782 8.83888L16.1782 8.8389L16.1826 8.84141C16.3372 8.92971 16.4658 9.05735 16.5553 9.21139C16.6447 9.36543 16.6918 9.54038 16.6918 9.71849C16.6918 9.89661 16.6447 10.0716 16.5553 10.2256C16.4658 10.3796 16.3373 10.5073 16.1826 10.5956Z" fill="#0855C4" stroke="#0855C4" stroke-width="1.43661"/>
            </svg>
          .detail
            h3.omnesMedium ¿Qué puedo hacer en ZS?
            p.omnesRegular Te enseñamos todo lo que puedes hacer en tu portal de usuario Zona Segura.
      .card-tutorial.g-flex.g-justify-center.g-align-center.cursor-pointer(@click="showDialogVideo('dialogVideo2')" :class="{'selected': dialogVideo2}")
        .play.g-flex.g-justify-center.g-align-center
          <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.1826 10.5956L16.1826 10.5956L16.1782 10.5981L2.46672 18.5539C2.46663 18.5539 2.46653 18.554 2.46644 18.5541C1.7596 18.9635 0.888228 18.4542 0.888228 17.6734V1.76146C0.888228 0.981933 1.75816 0.471838 2.46636 0.882879L2.46644 0.882927L16.1782 8.83888L16.1782 8.8389L16.1826 8.84141C16.3372 8.92971 16.4658 9.05735 16.5553 9.21139C16.6447 9.36543 16.6918 9.54038 16.6918 9.71849C16.6918 9.89661 16.6447 10.0716 16.5553 10.2256C16.4658 10.3796 16.3373 10.5073 16.1826 10.5956Z" fill="#0855C4" stroke="#0855C4" stroke-width="1.43661"/>
          </svg>
        .detail
          h3.omnesMedium ¿Ya estás registrado?
          p.omnesRegular Aprende cómo registrarte si eres nuevo y cómo recuperar tu contraseña.
    //- MOBILE
    v-fade-transition(v-if="$vuetify.breakpoint.smAndDown")
      .container-mobile(v-show="showGuide" @click="openGuideMobile = true")
        .g-flex.g-justify-center.g-align-center
          .play.g-flex.g-justify-center.g-align-center
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.1826 10.5956L16.1826 10.5956L16.1782 10.5981L2.46672 18.5539C2.46663 18.5539 2.46653 18.554 2.46644 18.5541C1.7596 18.9635 0.888228 18.4542 0.888228 17.6734V1.76146C0.888228 0.981933 1.75816 0.471838 2.46636 0.882879L2.46644 0.882927L16.1782 8.83888L16.1782 8.8389L16.1826 8.84141C16.3372 8.92971 16.4658 9.05735 16.5553 9.21139C16.6447 9.36543 16.6918 9.54038 16.6918 9.71849C16.6918 9.89661 16.6447 10.0716 16.5553 10.2256C16.4658 10.3796 16.3373 10.5073 16.1826 10.5956Z" fill="#0855C4" stroke="#0855C4" stroke-width="1.43661"/>
            </svg>
          .detail
            p.omnesMedium Te enseñamos todo lo que puedes hacer en Zona Segura, ingresa&nbsp;
              span.omnesMedium aquí
          .close(@click.stop="showGuide = false")
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.5524 6.47266L7.14062 18.8844" stroke="#0855C4" stroke-width="2.06862" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.14062 6.47266L19.5524 18.8844" stroke="#0855C4" stroke-width="2.06862" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
    //- MOBILE: MODAL VIDEO LIST
    v-dialog(v-model="openGuideMobile" persistent scrollable width="auto")
      v-card.guide-modal
        .close
          v-btn(icon dark @click="openGuideMobile = false")
            v-icon(color="#0855C4") close
        v-card-title.omnesMedium Elige la opción que deseas aprender
        v-card-text(style="height: 500px; margin-bottom: 15px; padding-right: 15px")
          .card-tutorial.mb-5
            .number.omnesMedium.g-flex.g-justify-center.g-align-center 1
            .detail
              h3.omnesSemibold Introducción a Zona Segura
              p.omnesRegular Te enseñamos todo lo que puedes hacer en tu portal de usuario Zona Segura.
              .preview(@click="dialogVideo1 = true")
                img(:src="images.preview1", alt="Introducción a Zona Segura")
          .card-tutorial
            .number.omnesMedium.g-flex.g-justify-center.g-align-center 2
            .detail
              h3.omnesSemibold ¿Eres nuevo?
              p.omnesRegular Aprende cómo registrarte si eres nuevo y cómo recuperar tu contraseña.
              .preview(@click="dialogVideo2 = true")
                img(:src="images.preview2", alt="¿Eres nuevo?")
    DialogVideo(
      @closeDialogVideo="closeMethod"
      :show="dialogVideo1"
      :videoId="'MXasyBzUcsE'"
    )
    DialogVideo(
      @closeDialogVideo="closeMethod"
      :show="dialogVideo2"
      :videoId="'zMmZoilEK9s'"
    )
    PopupAlertMessage(
      @closeAlertPopup="closeMethod"
      :openPopup="flagPopupAlert"
      :image="images.info"
      :title="'¡Ya falta poco!'"
      :message="'Muy pronto el video estará disponible.'"
      :messageButton="'Entendido'"
    )
</template>
<script>
import DialogVideo from '@/components/login/DialogVideo'
import PopupAlertMessage from '@/components/PopupAlertMessage'

export default {
  data () {
    return {
      pulseActive: false,
      showGuide: false,
      openGuideMobile: false,
      dialogVideo1: false,
      dialogVideo2: false,
      images: {
        preview1: require('@/assets/login/preview1.jpg'),
        preview2: require('@/assets/login/preview2.jpg'),
        info: require('@/assets/characters/informa.svg')
      },
      flagPopupAlert: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.showGuide = true
      this.pulseActive = true
      if (this.pulseActive) {
        setTimeout(() => { this.pulseActive = false }, 10000)
      }
    }, 2000)
  },
  methods: {
    showDialogVideo (video) {
      this[video] = true
      this.pulseActive = false
    },
    closeMethod () {
      this.dialogVideo1 = false
      this.dialogVideo2 = false
      this.flagPopupAlert = false
    }
  },
  components: {
    DialogVideo,
    PopupAlertMessage
  }
}
</script>
<style scoped>

.guide-modal {
  border-radius: 5px;
  padding: 15px;
}

.guide-modal .close {
  display: flex;
  justify-content: end;
  align-items: flex-end;
  padding: 15px;
}

.guide-modal .close .v-btn {
  width: auto;
  height: auto;
  padding: 5px;
  position: absolute;
  top: 0;
  right: 0;
}

.guide-modal .v-card__title {
  color: var(--first-brand-color);
  font-size: 18px;
  justify-content: center;
  line-height: normal;
  padding: 0 0 23px;
  text-align: center;
}

.guide-modal .v-card__text {
  padding: 0;
}

.guide-modal .card-tutorial {
  display: flex;
  justify-content: center;
  gap: 13px;
}

.guide-modal .card-tutorial .number {
  min-width: 40px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--first-brand-color);
  border-radius: 50%;
  color: var(--first-brand-color);
  font-size: 20px;
  line-height: normal;
}

.guide-modal .card-tutorial .detail {
  width: 80%;
}

.guide-modal .card-tutorial .detail h3,
.guide-modal .card-tutorial .detail p {
  color: var(--text-color);
  font-size: 16px;
  line-height: normal;
}

.guide-modal .card-tutorial .detail h3 {
  margin-bottom: 3px;
}

.guide-modal .card-tutorial .detail p {
  margin-bottom: 23px;
}

.guide-modal .card-tutorial .preview img {
  display: flex;
  width: 100%;
  border-radius: 10px;
}

@media screen and (max-width: 1024px) {
  .container-mobile {
    background-color: #EAECF2;
    bottom: 0;
    height: 75px;
    padding: 0 20px;
    position: fixed;
    width: 100%;
    z-index: 1;
  }

  .container-mobile .g-flex {
    height: inherit;
    gap: 25px;
  }

  .container-mobile .g-flex .play {
    border: 1px solid var(--first-brand-color);
    min-width: 43px;
    width: 43px;
    height: 43px;
    border-radius: 50%;
    transition: .3s ease-in-out;
  }

  .container-mobile .g-flex .detail p {
    color: var(--text-color);
    font-size: 16px;
    line-height: normal;
    margin: 0;
  }

  .container-mobile .g-flex .detail span {
    color: var(--first-brand-color);
    text-decoration: underline;
  }
}

@media screen and (min-width: 1024px) {
  .container-desktop {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 30px;
  }

  .container-desktop .container-first-card {
    width: auto;
    height: auto;
    position: relative;
  }

  .container-desktop .pulse {
    width: 95%;
    height: 100%;
    border-radius: 27px;
    outline: 1px solid transparent;
    background-color: white;
    animation: pulse 1.5s ease-out infinite;
    position: absolute;
  }

  .container-desktop .card-tutorial {
    border-radius: 27px;
    border: 2px solid rgba(242, 242, 242, 0.25);
    padding: 10px 15px;
    gap: 15px;
    background: rgba(255, 255, 255, 0.01);
    backdrop-filter: blur(17px);
    transition: .3s ease-in-out;
  }

  .container-desktop .card-tutorial .play {
    background-color: white;
    border: 1px solid white;
    min-width: 43px;
    width: 43px;
    height: 43px;
    border-radius: 50%;
    transition: .3s ease-in-out;
  }

  .container-desktop .card-tutorial .detail h3,
  .container-desktop .card-tutorial .detail p {
    color: white;
    margin: 0;
  }
  .container-desktop .card-tutorial .detail h3 {
    font-size: 16px;
  }
  .container-desktop .card-tutorial .detail p {
    font-size: 14px;
    line-height: 1.15;
  }
  .container-desktop .card-tutorial:hover,
  .container-desktop .card-tutorial.selected {
    border-color: var(--first-brand-color);
    background-color: white;
    color: var(--text-color);
  }
  .container-desktop .card-tutorial:hover .play,
  .container-desktop .card-tutorial.selected .play {
    border-color: var(--first-brand-color);
  }
  .container-desktop .card-tutorial:hover .detail h3,
  .container-desktop .card-tutorial:hover .detail p,
  .container-desktop .card-tutorial.selected .detail h3,
  .container-desktop .card-tutorial.selected .detail p {
    color: var(--text-color);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login/GuideOnboarding.vue